import React from 'react';
import PropTypes from 'prop-types';
import { Space, Button } from '../../ds';
import IconError from './icon-error.svg';
import './errorModal.scss';

const ErrorModal = ({ title, message, textButton, onClose = () => null }) => {
  return (
    <div className='error-body k-ds-width-full'>
      <Space justify='center' direction='vertical' align='center'>
        <img width={80} height={80} src={IconError} alt='error...' />
      </Space>
      <Space className='k-ds-heading-05 k-ds-m-top-sp-07' justify='center'>
        {title}
      </Space>
      <Space
        className='k-ds-body-02 error-content k-ds-m-top-sp-05'
        justify='center'
      >
        <span dangerouslySetInnerHTML={{ __html: message }} />
      </Space>
      <Space className='k-ds-m-top-sp-03' justify='center'>
        <Button
          type='primary-alternate'
          className='cta-button k-ds-m-top-sp-06'
          horizontalPadding='34.4px'
          verticalPadding='16px'
          size='large'
          onClick={onClose}
        >
          {textButton}
        </Button>
      </Space>
    </div>
  );
};

ErrorModal.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  textButton: PropTypes.string,
};

export default ErrorModal;
